// extracted by mini-css-extract-plugin
var _1 = "WYpHF";
var _2 = "_IH0K";
var _3 = "k2UTx";
var _4 = "Yc4LX";
var _5 = "zY8Kk";
var _6 = "mQzvn";
var _7 = "AuBSZ";
var _8 = "GliIs";
var _9 = "VqSN7";
var _a = "ON26y";
var _b = "BGoUx";
export { _1 as "base", _2 as "disabled", _3 as "fitToParent", _4 as "justify-center", _5 as "justify-end", _6 as "justify-start", _7 as "size-compact", _8 as "size-standard", _9 as "tab", _a as "theme-dark", _b as "theme-light" }
